import { Alert, Box, Collapse, Container, IconButton } from "@mui/material";
import { Outlet } from "react-router-dom";
import { ReactNode, useState } from "react";
import { X } from "lucide-react";

type DefaultLayoutProps = {
    children?: ReactNode;
};

export default function DefaultLayout({ children }: DefaultLayoutProps) {
    const [bannerOpen, setBannerOpen] = useState(() => {
        try {
            return localStorage.getItem('beta_banner_dismissed') !== 'true';
        } catch {
            return true;
        }
    });

    function dismissBanner() {
        setBannerOpen(false);
        try {
            localStorage.setItem('beta_banner_dismissed', 'true');
        } catch (e) {
            console.error('Failed to save banner dismissal state', e);
        }
    }

    return (
        <Box display={"flex"} flexDirection={"column"} width={"100%"} minHeight={"100dvh"}>
            <Collapse in={bannerOpen}>
                <Alert
                    severity="warning"
                    sx={{ borderRadius: 0, justifyContent: "center", textAlign: "center" }}
                    action={
                        <IconButton size="small" onClick={dismissBanner} aria-label="dismiss">
                            <X size={16} />
                        </IconButton>
                    }
                >
                    🍺 <strong>Beta version</strong> — This is an early release. Bugs and crashes may occur, but luckily you don't need fun to drink beer. If something breaks, please let us know on <a href="https://www.instagram.com/moesbeergame/" target="_blank">Instagram</a>. Last update on 16th of June. Thanks for playing!
                </Alert>
            </Collapse>
            <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flex={1}
            >
                <Container maxWidth="xl">
                    {children ?? <Outlet />}
                </Container>
            </Box>
        </Box>
    );
}
